import { render } from "./KapibaraPrice.vue?vue&type=template&id=1018abec"
import script from "./KapibaraPrice.vue?vue&type=script&lang=js"
export * from "./KapibaraPrice.vue?vue&type=script&lang=js"

import "./KapibaraPrice.vue?vue&type=style&index=0&id=1018abec&lang=scss"

import exportComponent from "D:\\experement\\kapibara\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__